import { AccessoryType } from './accessory-type.enum';
import { ChargerCurrentType } from './charger-current-type.enum';
import { ChargerPhaseType } from './charger-phase-type.enum';
import { ChargerUsingType } from './charger-using-type.enum';

export class ChargerProperties {
	brand: string;
	chargerPhaseType: ChargerPhaseType;
	numberOfConnectors: number;
	currentType: ChargerCurrentType;
	maximumPower: number;
	ratedVoltage: number;
	maxCurrent: number;
	chargerUsingType: ChargerUsingType;
	cableIncluded: boolean;
	poleNeeded: boolean;
	requiredAccessoryTypes: AccessoryType[];
	homeUsage: boolean;
	officeUsage: boolean;

	get currentTypeText() {
		switch (this.currentType) {
			case ChargerCurrentType.AC: {
				return 'slow';
			}
			case ChargerCurrentType.DC: {
				return 'fast';
			}
			default: {
				return 'N/A';
			}
		}
	}
}
